/** Phần không phụ thuộc store — an toàn để import từ lib/progress. */
export type Lang = "vi" | "en";

/** Chuỗi song ngữ dùng trong dữ liệu (không phải component). */
export interface L {
  vi: string;
  en: string;
}

export function isLang(v: unknown): v is Lang {
  return v === "vi" || v === "en";
}

export function pick(l: L, lang: Lang): string {
  return lang === "en" ? l.en : l.vi;
}

export function locale(lang: Lang): string {
  return lang === "en" ? "en-US" : "vi-VN";
}
